/* Copyright (c) 2020-present CloudIO Inc */

import { ActionProps } from 'componentregistry';
import { isNotEmpty } from 'utils/isEmpty';

const fireClickEvent = (element: HTMLAnchorElement) => {
  if (
    navigator.userAgent.indexOf('MSIE') !== -1 ||
    // @ts-ignore to-do
    !!document.documentMode === true
  ) {
    if (document.body != null) {
      document.body.appendChild(element);
      element.click();
    }
  } else {
    const event = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    });
    element.dispatchEvent(event);
  }
};

export function openURL(urlValue: string, openInNewTab: boolean): void {
  const openUrlEle = document.createElement('a');
  openUrlEle.href = urlValue;
  if (openInNewTab) {
    openUrlEle.target = '_blank';
  }
  fireClickEvent(openUrlEle);
}

async function OpenURL(props: ActionProps<'ActionOpenURL'>): Promise<boolean> {
  const { appUid, platform, pageId, itemId, url, openInNewTab } = props;
  let urlValue = platform.evalIfExpressionString(
    appUid,
    pageId,
    itemId,
    'url',
    { ...props },
    url,
  );

  if (isNotEmpty(urlValue)) {
    platform
      .getChildrenOfTypeById(appUid, pageId, itemId, 'ActionURLParam')
      .forEach((child) => {
        const { paramName, value, disableCondition } = child.props;
        if (
          platform.evalBoolean(
            appUid,
            pageId,
            child.itemId,
            'disableCondition',
            { ...child.props },
            disableCondition,
          )
        ) {
          const valueResult = platform.evalIfExpressionString(
            appUid,
            pageId,
            child.itemId,
            'value',
            { ...child.props },
            value,
          );
          if (isNotEmpty(paramName)) {
            if (urlValue?.indexOf('?') === -1) {
              urlValue = `${urlValue}?`;
            } else {
              urlValue = `${urlValue}&`;
            }
            urlValue = `${urlValue}${paramName}=${valueResult ?? ''}`;
          }
        }
      });
    openURL(urlValue, openInNewTab);
    return true;
  }

  platform.showError(
    `Invalid URL [${urlValue}] specified in Action [Item ID: ${itemId}]`,
    { pageId, itemId, appUid },
  );
  return false;
}

export default OpenURL;
